import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap, pluck } from 'rxjs/operators';

import { Injectable, signal, inject, effect } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StoreConfigurationRepositoryService } from '../store-configuration/store-configuration-repository.service';

// todo default
export const DEFAULT_PAGE_TITLE = 'Shop Now';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private title = inject(Title);
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);

  // Signal for current page title
  private _currentTitle = signal<string>(DEFAULT_PAGE_TITLE);
  readonly currentTitle = this._currentTitle.asReadonly();

  constructor() {
    // Effect to handle router events and update title
    effect(() => {
      const routerEvents$ = this.router.events.pipe(
        filter((navigation => navigation instanceof NavigationEnd)),
        map(() => this.route),
        map((route: ActivatedRoute) => {
          let currentRoute: ActivatedRoute = route;
          while (currentRoute.firstChild) { currentRoute = currentRoute.firstChild; }
          return currentRoute;
        }),
        filter((route: any) => route.outlet === 'primary'),
        mergeMap((route: any) => route.data),
        pluck('title'),
        map((title: unknown) => this.router.url === '/' ? this.storeConfigurationRepositoryService.homePageTitle() : (title as string)),
        map((title: string) => title ? title : this.getTitle())
      );

      // Subscribe to the observable and update signal
      const subscription = routerEvents$.subscribe((title: any) => {
        this._currentTitle.set(title);
        this.setTitleWithCompanyName(title);
      });

      // Cleanup subscription when effect is destroyed
      return () => subscription.unsubscribe();
    });
  }

  /**
   * 
   * @param title @deprecated does not use dynamic company name
   * @returns 
   */
  setTitle(title: string) {
    if (!title) {
      return;
    }
    this.title.setTitle(title);
  }

  setTitleWithCompanyName(title: string) {
    if (!title) {
      return;
    }
    const companyName = this.storeConfigurationRepositoryService.companyName();
    this.title.setTitle(title.concat(` | ${companyName}`));
  }

  private getTitle() {
    // Use a default value since we can't easily access the Observable value here
    return DEFAULT_PAGE_TITLE;
  }
}
